import { fork } from 'redux-saga/effects';
import { watchOrganizationActions } from './OrganizationSaga';
import { watchUserActions } from './UserSaga';



export default function* root() {
    yield fork(watchOrganizationActions);
    yield fork(watchUserActions);
}